import { z } from "zod";

export const linkChildSchema = z.object({
  family_code: z
    .string()
    .min(1, "Family code is required")
    .max(50)
    .transform((v) => v.trim()),
});

export type LinkChildInput = z.infer<typeof linkChildSchema>;

// 189 -- parent creates a child from scratch (no family code, no school yet).
// The child gets a Player + ParentPlayer link; the school association is
// established later when a coach approves an enrollment request (188).
export const createChildSchema = z.object({
  first_name: z.string().min(1, "First name is required").max(100),
  surname: z.string().min(1, "Surname is required").max(100),
  date_of_birth: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "Date of birth must be YYYY-MM-DD"),
  nickname: z.string().max(100).nullable().optional(),
  grade: z.number().int().min(0).max(13).nullable().optional(),
});

export type CreateChildInput = z.infer<typeof createChildSchema>;

// 190 -- parent edits an existing child's identity. All fields optional; a
// material change (first_name / surname / date_of_birth) alerts the child's
// coaches. The child stays on the roster (notify-only, no re-approval).
export const updateChildSchema = z.object({
  first_name: z.string().min(1).max(100).optional(),
  surname: z.string().min(1).max(100).optional(),
  date_of_birth: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Date of birth must be YYYY-MM-DD").optional(),
  nickname: z.string().max(100).nullable().optional(),
});

export type UpdateChildInput = z.infer<typeof updateChildSchema>;
